import { Component, OnInit, ViewChild, Input, Output, EventEmitter,ElementRef } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { finalize } from 'rxjs/operators';
import { ExceptionHandlingService } from 'src/app/shared/exception-handling.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, IMyOptions } from 'ng-uikit-pro-standard';
@Component({
  selector: 'email-selection-notices',
  templateUrl: './email-selection-notices.component.html'
})
export class EmailSelectionNoticesModalComponent implements OnInit {

  @Input() selections: any;
  @Output() emitSuccess = new EventEmitter<any>();
  error: any = {}

  constructor(
    private service: SharedService,
    private appConstants: AppConstants,
    private errorService: ExceptionHandlingService,
    private toastr: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit() {}

  datePickerOptions: IMyOptions = {
    dateFormat: 'mmm-dd-yyyy',
    closeAfterSelect: true,
    editableDateField:false
  };

  @ViewChild('emailModal', { static: true }) emailModal: any;
  action: any = {};
  emailSelectionType:string;
  ngOnChanges() {
    if (
      this.selections && this.selections.selectedSelections && this.selections.selectedSelections.length) {
      this.emailSelectionType = this.selections.type;    
      this.action = {};
      this.action = { tagId: null, testEmailOnly: true, copyContacts: [] };
      this.sourceData = null
      this.iframe.nativeElement.contentWindow.document.location.reload();
      this.getNoticeType().then(res => { this.action.tagId = this.noticeTypes.selectionLetterTag; this.getNotificationTypes() })
      this.emailModal.show();
    }
  }

  emailModalNotificationTyeChanged() {
    this.notificationTemplates = [];
    this.action.notificationTemplate = {}
    this.sourceData = null;
    this.iframe.nativeElement.contentWindow.document.location.reload();
    this.getNotificationTypes()
  }

  notificationTemplates: any = [];
  notificationTemplatesLoading: boolean = false;
  getNotificationTemplates() {
    const url = this.appConstants.endPoints.notificationEndPoint + 'admin/templates';
    this.notificationTemplatesLoading = true;
    this.service.get(url, { status: true })
      .pipe(finalize(() => {
        this.notificationTemplatesLoading = false;
      }))
      .subscribe(data => {
        this.notificationTemplates = data && data.searchResults ? data.searchResults : []
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })
  }

  getNotificationTypes() {
    const url = this.appConstants.endPoints.notificationEndPoint + 'options/admin/notification-templates-by-business-code';
    this.notificationTemplatesLoading = true;
    this.service.post(url, {}, [this.action.tagId.name])
      .pipe(finalize(() => {
        this.notificationTemplatesLoading = false;
      }))
      .subscribe(data => {
        let selectedActionTypeName = this.action.tagId.name;
        let notificationTemplates = data && data[selectedActionTypeName] ? data[selectedActionTypeName] : [];
        this.notificationTemplates = notificationTemplates.map(res => { return { id: res.id, name: res.name } })
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })

  }


  @ViewChild('iframe', { static: true }) iframe: ElementRef

  sourceData: any
  getSource(value) {
    let data = value.mergedText;
    this.sourceData = data;
    this.iframe.nativeElement.contentWindow.document.open();
    this.iframe.nativeElement.contentWindow.document.write(data);
  }

  noticeTypesLoading : boolean = false
  getTemplate(e) {

    if (e && e.id) {
      const url = this.appConstants.endPoints.notificationEndPoint + 'admin/templates/' + e.id + '/merge-text';
      this.noticeTypesLoading = true;
      this.service.get(url, {})
        .pipe(finalize(() => {
          this.noticeTypesLoading = false;
        }))
        .subscribe(data => {
          if (this.iframe)
            this.iframe.nativeElement.contentWindow.document.close();
          this.getSource(data)
        }, error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })
    }

    else {
      this.sourceData = null
      this.iframe.nativeElement.contentWindow.document.location.reload();
    }

  }
  emailSelectionsLoading: boolean = false;
  confirmEmailSelections() {
    let url = '';
  
  
    url = this.appConstants.endPoints.certificatesEndPoint + 'critical-components/applicant-component-selections/batch-operations/email';
    

    this.noticeTypesLoading = true
    let modelSchema = {
      "copyContacts": "",
      "notificationTemplateId": this.action.notificationTemplate.id,
      "tagId": this.action && this.action.tagId ? this.action.tagId.id : null
    }

    if(this.emailSelectionType == 'custom'){
      url = this.appConstants.endPoints.certificatesEndPoint + 'custom-selections/'+this.selections.customSelection.id+'/email-selections';
      modelSchema['tagId'] = "00000000-0000-0000-0000-000000000000"
    }


    if (this.action.copyContacts && this.action.copyContacts.length)
      modelSchema['copyContacts'] = this.action.copyContacts.join(",");
    modelSchema['testEmail'] = this.action.testEmailOnly;


    const criteria = {};

    if (this.selections.selection.selectionYear) {
      let selectedYear = new Date(this.selections.selection.selectionYear);
      criteria["selectionYear"] = (selectedYear).getFullYear();
    }
    if (this.selections.selection.region)
      criteria["regionId"] = this.selections.selection.region.id

    if (this.selections.selection.customerDisplayName)
      criteria["customerDisplayName"] = this.selections.selection.customerDisplayName

    if (this.selections.selection.name)
      criteria["name"] = this.selections.selection.name

    if (this.selections.selection.status)
      criteria["status"] = this.selections.selection.status
    criteria["pageNumber"] = this.selections.pageInfo.currentPage;
    criteria["pageSize"] = this.selections.pageInfo.itemsPerPage;
    criteria["isPaging"] = true;
    criteria['applicantComponentSelectionIds'] = this.selections.selectedSelections;

    modelSchema["criteria"] = criteria;
    modelSchema["selectAll"] = this.selections.selectAllOption.isAllSelected;

    this.emailSelectionsLoading = true;
    this.service.post(url, {}, modelSchema).pipe(finalize(() => {
      this.emailSelectionsLoading = false;
    }))
      .pipe(finalize(() => {
        this.noticeTypesLoading = false;
      })).subscribe(data => {
        this.emailModal.hide();
        this.emitSuccess.emit(true)
        this.toastr.success(this.translate.instant('administration_selectionsEmailedSuccessfully_label'), this.translate.instant('administration_success_label'))
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }

  
  noticeTypes: any = {};
  downloadNotice: any = {};
  getNoticeType() {
    this.noticeTypes = {};
    const url = this.appConstants.endPoints.certificatesEndPoint + 'admin/critical-components/settings';
    this.noticeTypesLoading = true;

    return new Promise((resolve, reject) => {
      this.service.get(url, {})
        .pipe(finalize(() => {
          this.noticeTypesLoading = false;
        }))
        .subscribe(data => {
          if (data) {
            if (data.selectionLetterTag.id)
              this.noticeTypes['selectionLetterTag'] = { id: data.selectionLetterTag.id, name: data.selectionLetterTag.name, index: 1 };
            if (data.reminderLetterTag.id)
              this.noticeTypes['reminderLetterTag'] = { id: data.reminderLetterTag.id, name: data.reminderLetterTag.name, index: 2 };
            if (data.lateNoticeLetterTag.id)
              this.noticeTypes['lateNoticeLetterTag'] = { id: data.lateNoticeLetterTag.id, name: data.lateNoticeLetterTag.name, index: 3 };
          }
          resolve(this.noticeTypes)
        }
          , error => {
            this.errorService.errorHandling(error).then(res => {
              this.error = res;
            });
          })
    });

  }

  
}